import React from "react";
import { Outlet } from "react-router-dom";
import { VaultHeader } from "@/components/digibox/VaultHeader";
import "@/styles/digibox-vault.css";

export const DigiBoxLayout: React.FC = () => {
  return (
    <div className="vault-layout">
      <VaultHeader />
      <Outlet />
    </div>
  );
};
